import { CREATE_TEMPLATE_BUTTON_VARIANTS } from './constants';

export function isTextTemplatesTab(activeTab) {
  return String(activeTab) === 'text';
}

export function resolveCreateButtonVariant(activeTab) {
  return isTextTemplatesTab(activeTab)
    ? CREATE_TEMPLATE_BUTTON_VARIANTS.TEXT_DROPDOWN
    : CREATE_TEMPLATE_BUTTON_VARIANTS.DEFAULT;
}
